import styled, { css } from 'styled-components';
import { MemberEntitlementState } from '@yoweb/types/enums';
import { CreditCardsIcon } from '@yoweb/ui/components/Icon/CreditCardsIcon';
import { MembershipIcon } from '@yoweb/ui/components/Icon/MembershipIcon';
import { PaymentListIcon } from '@yoweb/ui/components/Icon/PaymentListIcon';
import { ProfileIcon } from '@yoweb/ui/components/Icon/ProfileIcon';
import { useTranslation } from '@yoweb/next-i18next';
import { API_LOGOUT, PAGE_ACCOUNT, PAGE_MEMBERSHIP, PAGE_PAYMENTS, PAGE_WALLET } from '@store/constants/routes';
import { useUser } from '@store/hooks/useUser';
import { getColor, getFontSize, getFontWeight, getSpace } from '@yoweb/ui/styles/utils/theme';
import { pxToRem } from '@yoweb/ui/styles/utils';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { logoutEvent } from '@yoweb/utils/analytics/mixpanel';
import { jsx as _jsx } from "react/jsx-runtime";
export var IDS = {
  USER_MENU_LINK: 'ppvr-usrmn-lnk'
};

var menuLinks = function menuLinks(basePoplarUrl, mixpanelTrackingCookieDomain) {
  return [{
    icon: ProfileIcon,
    id: 'account-sections.profile',
    label: 'account-sections.profile',
    path: PAGE_ACCOUNT(basePoplarUrl)
  }, {
    icon: MembershipIcon,
    id: 'account-sections.membership',
    label: 'account-sections.membership',
    path: PAGE_MEMBERSHIP(basePoplarUrl),
    isLowerLevelItem: true
  }, {
    icon: CreditCardsIcon,
    id: 'account-sections.payment-cards',
    label: 'account-sections.payment-cards',
    path: PAGE_WALLET(basePoplarUrl),
    isLowerLevelItem: true
  }, {
    icon: PaymentListIcon,
    id: 'account-sections.payment-history',
    label: 'account-sections.payment-history',
    path: PAGE_PAYMENTS(basePoplarUrl),
    isLowerLevelItem: true
  }, {
    id: 'sign-out',
    label: 'sign-out',
    path: API_LOGOUT,
    onClick: function onClick() {
      logoutEvent(mixpanelTrackingCookieDomain);
    }
  }];
};

var previewStatuses = [MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_UNSPECIFIED, MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_PREVIEW];

var getMenuLinks = function getMenuLinks(user, basePoplarURL, mixpanelTrackingCookieDomain) {
  var _user$entitlement, _user$profile;

  var memberEntitlementState = user === null || user === void 0 ? void 0 : (_user$entitlement = user.entitlement) === null || _user$entitlement === void 0 ? void 0 : _user$entitlement.state;
  var isPreviewSubscription = // eslint-disable-next-line eqeqeq
  memberEntitlementState != null && previewStatuses.includes(memberEntitlementState);
  var hidePayment = !(user !== null && user !== void 0 && (_user$profile = user.profile) !== null && _user$profile !== void 0 && _user$profile.stripeCustomerId) || isPreviewSubscription;
  var links = menuLinks(basePoplarURL, mixpanelTrackingCookieDomain);

  if (hidePayment) {
    links = links.filter(function (link) {
      return !["".concat(PAGE_WALLET(basePoplarURL)), "".concat(PAGE_PAYMENTS(basePoplarURL))].includes(link.path);
    });
  }

  return links;
};
/**
 * User menu list (different view for desktop/mobile)
 */


var UserMenuLinks = function UserMenuLinks(_ref) {
  var className = _ref.className,
      LinkComponent = _ref.linkComponent;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var user = useUser();

  var _useExternalConfig = useExternalConfig(),
      basePoplarURL = _useExternalConfig.basePoplarURL,
      mixpanel = _useExternalConfig.mixpanel;

  if (!user) {
    return null;
  }

  var links = getMenuLinks(user, basePoplarURL, mixpanel.domain);
  return /*#__PURE__*/_jsx(UserMenu, {
    className: className,
    children: links.map(function (link, i) {
      var isLastInGroup = link.isLowerLevelItem && (i === links.length - 1 || !links[i + 1].isLowerLevelItem);

      if (LinkComponent !== undefined) {
        return /*#__PURE__*/_jsx(LinkComponent, {
          link: link
        }, link.id);
      }

      return /*#__PURE__*/_jsx(AnchorLink, {
        href: link.path,
        "data-testid": IDS.USER_MENU_LINK,
        isLowerLevelLink: link.isLowerLevelItem,
        isLastInLowerLevelGroup: isLastInGroup,
        onClick: function onClick() {
          var _link$onClick;

          return (_link$onClick = link.onClick) === null || _link$onClick === void 0 ? void 0 : _link$onClick.call(link);
        },
        children: t(link.label)
      }, link.id);
    })
  });
};

var UserMenu = styled.div.withConfig({
  componentId: "sc-lj7fqz-0"
})(["padding:", " 0;"], getSpace('small3'));
var AnchorLink = styled.a.withConfig({
  componentId: "sc-lj7fqz-1"
})(["white-space:nowrap;color:", ";display:block;font-size:", ";line-height:", ";padding:", " ", " ", " ", ";", " ", " &:hover{background-color:", ";}"], getColor('base900'), getFontSize('bodyLg'), pxToRem(22), getSpace('small4'), getSpace('normal2'), pxToRem(15), getSpace('normal2'), function (_ref2) {
  var isLowerLevelLink = _ref2.isLowerLevelLink;
  return isLowerLevelLink ? css(["padding-left:", ";"], getSpace('normal4')) : css(["font-weight:", ";"], getFontWeight('bold'));
}, function (_ref3) {
  var isLastInLowerLevelGroup = _ref3.isLastInLowerLevelGroup;
  return isLastInLowerLevelGroup && css(["margin-bottom:", ";"], getSpace('small3'));
}, getColor('base050'));
export default UserMenuLinks;